import { useRoute, useRouter } from 'vue-router'
import useGet from '../../../core/composables/api/useGet'
import { computed, onMounted } from 'vue'
import { FeedbackTopicType, type FeedbackTopic } from '../../../core/models/feedback-topic'
import type { Dialog } from '../../../core/models/dialog/dialog'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import usePut from '../../../core/composables/api/usePut'
import { ApiRequestStatus } from '../../../core/models/api/api-request-status'
import { useSnackStore } from '../../../stores/snack.store'

export const useCoacheePrepareDialog = () => {
  const route = useRoute()
  const router = useRouter()

  const snackStore = useSnackStore()
  const { data, load, status, reload } = useGet<DialogPrepareForCoachee>(
    `dialog/prepare/${route.params.id}`,
  )

  onMounted(() => {
    load()
  })

  const eventBus = useEventBus(EventKey.dialogSlideUpdated)
  eventBus.on(() => reload())

  const unfinishedTopics = computed(() => {
    if (data.value) {
      return data.value.feedbackTopics.filter(
        (topic) => topic.savedAt == undefined && topic.type != FeedbackTopicType.Journal,
      )
    }
    return []
  })

  const unfinishedSurveys = computed(() => {
    if (data.value) {
      return data.value.selectedSurveys.filter((survey) => !survey.isFinished)
    }
    return []
  })

  const { mutate, status: releaseStatus } = usePut<string, string>(
    `dialog/coachee-release/${route.params.id}`,
  )

  const canReleaseDialog = computed(() => {
    return unfinishedTopics.value.length == 0
  })

  const releaseDialog = async () => {
    if (!canReleaseDialog.value) {
      return
    }

    await mutate(route.params.id as string)

    if (releaseStatus.value == ApiRequestStatus.Success) {
      router.push({ name: 'dialogs' })
      snackStore.showInfo('Dialog freigegeben')
    } else {
      snackStore.showInfo('Dialog konnte nicht freigegeben werden')
    }
  }

  return {
    data,
    status,
    releaseDialog,
    releaseStatus,
    unfinishedTopics,
    unfinishedSurveys,
    canReleaseDialog,
  }
}

export interface DialogPrepareForCoachee {
  readonly dialog: Dialog
  readonly feedbackTopics: ReadonlyArray<FeedbackTopic & { savedAt?: string }>
  readonly selectedSurveys: ReadonlyArray<{
    id: string
    isFinished: boolean
  }>
}
